import { render, staticRenderFns } from "./WfButton.vue?vue&type=template&id=19bb5e84&scoped=true"
import script from "./WfButton.vue?vue&type=script&lang=js"
export * from "./WfButton.vue?vue&type=script&lang=js"
import style0 from "./WfButton.vue?vue&type=style&index=0&id=19bb5e84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bb5e84",
  null
  
)

export default component.exports